import { IconButton } from "@dropbox/dig-components/buttons";
import { Box, Stack } from "@dropbox/dig-foundations";
import { UIIcon } from "@dropbox/dig-icons";
import { ChevronDownLine, ChevronUpLine } from "@dropbox/dig-icons/assets";
import { Title } from "@mirage/mosaics/BaseProfilePage/Title";
import { UserProfileCard } from "@mirage/mosaics/BaseProfilePage/UserProfileCard";
import type {
  BasicUserInfo,
  UserInfo,
} from "@mirage/mosaics/UserProfilePage/types";
import { useState } from "react";

import styles from "./ProfileEmployees.module.css";

interface ProfileEmployeesProps {
  sectionTitle: string;
  employees: BasicUserInfo[];
  employee: UserInfo;
}

export const ProfileEmployees = (props: ProfileEmployeesProps) => {
  const [isHidden, setIsHidden] = useState(false);
  return (
    <Stack>
      <Box as="div" display="flex" alignItems="center" style={{ gap: "4px" }}>
        <Title size="small" weightVariant="emphasized" tagName="span">
          {props.sectionTitle}
        </Title>
        <IconButton
          variant="transparent"
          size="small"
          onClick={() => setIsHidden(!isHidden)}
        >
          {isHidden ? (
            <UIIcon src={ChevronDownLine} />
          ) : (
            <UIIcon src={ChevronUpLine} />
          )}
        </IconButton>
      </Box>
      {!isHidden && (
        <div className={styles.profileReportsList}>
          {props.employees.map((person) => (
            <UserProfileCard
              key={`user-profile-page-person__${person.user_id}`}
              user={person}
            />
          ))}
        </div>
      )}
    </Stack>
  );
};
